import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { singleBrandUrlRegex } from '../../../../shared/constants/single-brand-ulr-regex'
import type { ReviewsFilterQueryValues } from '../../../../shared/types/ReviewsFilters'
import { updateUrlQueryParams } from '../../../../shared/utils/update-url-query-params'

export const useUpdateFiltersHistory = () => {
  const history = useHistory()

  const updateFilterHistory = useCallback(
    (queryValues: ReviewsFilterQueryValues) => {
      let updatedUrl = updateUrlQueryParams(queryValues)

      if (!updatedUrl) {
        return
      }

      const isSingleBrand = singleBrandUrlRegex.test(updatedUrl)

      if (isSingleBrand) {
        updatedUrl = updatedUrl.replace(singleBrandUrlRegex, '')
        history.replace(updatedUrl, { updateQueryString: true })
        return
      }

      history.replace(updatedUrl, { updateQueryString: true })

      const nonCatFilterUrl = updatedUrl.replace(/(&filter.cat=[^&]*)/gi, '')
      const isOnlyOneFilterSelected = nonCatFilterUrl.match(/=/gi)?.length === 1
      const isOnlyOneBrandSelected = /^(.+filters.manufacturers.manufacturer=((?!%2).)*)$/.test(
        updatedUrl
      )

      if (isOnlyOneFilterSelected && isOnlyOneBrandSelected) {
        const { pathname } = window?.location
        const [, brandName] = updatedUrl.match(/filters.manufacturers.manufacturer=([\w-]+)/) || []

        if (brandName) {
          window?.history.replaceState({}, '', `${pathname}/${brandName}/brand`)
        }
      }
    },
    [history]
  )

  return {
    updateFilterHistory,
  }
}
